// @flow
import React, {useContext} from "react";
import * as PropTypes from "prop-types";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import GuiUtils from "../GUI_COMMON/SUPPORT/GuiUtils";

const CaseCard = ({caseId,caseNumber, dateStarted, dateModified, caseInOutItems, onClick}) => {
    
    const [globalState] = useContext(StoreContext);
    
    function handleOnClick() {
        if (onClick) {
            onClick();
        }
    }
    
    function dumpNumOut(numOut) {
        if(numOut===0) {
            return;
        }
        return <span className="badge badge-warning">Out:{numOut}</span>
    }
    function dumpNumTotal(numTotal) {
        return <span className="badge badge-info" data-toggle="tooltip" data-placement="auto" title="total samples">{numTotal}</span>
    }
    
    function dumpSampleInOutInfo() {
        return caseInOutItems.map((item, index) => {
            const name = GuiUtils.GetSampleTypeNameGivenId(item.sampleType, globalState.sampleTypes.items);
            return <tr key={index}>
                <td className="text-left">{name}</td>
                <td>{dumpNumTotal(item.numSamples)}</td>
                <td>{dumpNumOut(item.numSamplesOut)}</td>
            </tr>
        });
    }
    
    return (
        <div className="card li-case-card" onClick={handleOnClick}>
            <div className="card-body">
                <h4 className="card-title font-weight-bold text-left">{caseNumber ?? "-"}</h4>
                <div className="li-border-muted mb-1"></div>
                <div className="mb-5">
                    <table className="table table-sm li-bg-white li-border-round">
                        <tbody>
                            {dumpSampleInOutInfo()}
                        </tbody>
                    </table>
                </div>

                <div className="li-font-tiny li-fg-slightly-muted li-bottom-left">
                    <strong>First Archived:</strong> {LIUtils.shortDateFromJsonUtcDateStr(dateStarted)}<br/>
                    <strong>Last Modified:</strong> {LIUtils.shortDateFromJsonUtcDateStr(dateModified)}
                </div>

            </div>
        </div>
    );
}

CaseCard.propTypes =  {
    caseId: PropTypes.number,
    caseNumber: PropTypes.string,
    dateStarted: PropTypes.string,
    dateModified: PropTypes.string,
    caseInOutItems: PropTypes.array,
    onClick: PropTypes.func,
}

export default CaseCard;